<template>
  <div class="home-page">
    <div class="home pt-5 container d-flex">
      <div v-if="books.length == 0" class="text-center container text-dark">
        <h1>Welcome to My Book List Website</h1>
        <p>Start building your books list</p>
        <router-link to="/addbook" class="btn btn-warning"
          >Add New Book</router-link
        >
      </div>
      <ul class="row g-5 me-2 ms-0">
        <li
          v-for="book in books"
          :key="book.id"
          class="
            col-12 col-md-6 col-lg-4
            list-unstyled
            d-flex
            justify-content-between
            list
          "
        >
          <div class="card">
            <div class="card-img">
              <img
                src="../assets/book-cover.jpg"
                class="card-img-top"
                alt="Hollywood Sign on The Hill"
              />

              <div
                :class="{ icon: true, fav: book.isFav }"
                class="fav-sign"
              ></div>
            </div>

            <div class="details card-body">
              <h4 class="card-title fw-bolder">
                {{ book.title }}
              </h4>
              <p class="card-text">
                <span class="fw-bold">By: </span> {{ book.author }}
              </p>
              <p class="card-text">
                <span class="fw-bold">My review: </span> {{ book.review }}
              </p>
            </div>
            <div
              class="
                d-flex
                text-end
                ms-2
                me-2
                align-items-center
                justify-content-between
              "
            >
              <div class="d-flex align-items-center">
                <div @click="handleDelete(book)" class="icon">
                  <span class="material-symbols-outlined trash">
                    delete_forever
                  </span>
                </div>
                <!-- <div class="icon" @click="handleEdit(book.id)">
                  <span class="material-symbols-outlined ms-2 edit">
                    edit_note
                  </span>
                </div> -->
              </div>
              <div
                :class="{ icon: true, fav: book.isFav }"
                @click="handleUpdate(book)"
              >
                <span class="material-symbols-outlined"> star </span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <CreateBookForm />
    </div>
  </div>
</template>

<script>
import getCollection from "@/composables/getCollection";
import getUser from "@/composables/getUser";
// import { useRouter } from "vue-router";

// firebase imports
import { db } from "../firebase/config";
import { doc, deleteDoc, updateDoc } from "firebase/firestore";
export default {
  name: "Home",

  setup() {
    // const router = useRouter();

    const { user } = getUser();
    const { documents: books } = getCollection("books", [
      "userUid",
      "==",
      user.value.uid,
    ]);
    // delete docs
    const handleDelete = (book) => {
      const docRef = doc(db, "books", book.id);
      deleteDoc(docRef);
    };
    // update doc
    const handleUpdate = (book) => {
      const docRef = doc(db, "books", book.id);
      updateDoc(docRef, {
        isFav: !book.isFav,
      });
    };

    // const handleEdit = (book) => {
    //   doc(db, "books", book.id);
    //   router.push("/addbook:id");
    // };
    return { books, handleDelete, handleUpdate };
  },
};
</script>

<style>
.home-page {
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(255, 193, 7, 0.5) 50%,
    rgba(128, 97, 4, 0.5) 100%
  );
  background-repeat: no-repeat;
  background-size: cover;
  height: 3000px;
  padding-top: 50px;
  padding-bottom: 50px;
}

.card-img {
  position: relative;
  overflow: hidden;
}
.fav-sign.fav::after {
  content: "my fav ⭐";

  position: absolute;
  top: 11%;
  right: -50px;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 400;
  color: #333;
  background-color: #ffc107;
  padding: 4px 50px;
  transform: rotate(45deg);
  box-shadow: -1px 1px 49px -10px rgba(0, 0, 0, 0.45);
}

.card-title {
  color: #997404;
}
.icon {
  color: #bbbbbb;
  cursor: pointer;
}

.trash:hover {
  color: red;
}
.icon.fav {
  color: #ffc107;
}

.edit:hover {
  color: green;
}
</style>
